<template>
    <div>
      <buyform></buyform>
    </div>
  </template>
  
  <script>
    import buyform from '@/components/buy/index'
  export default {
    components: {
      buyform
    },
  }
  </script>
  
  <style>
  </style>
